
// As chaves de configuração agora são lidas de variáveis de ambiente.
// Certifique-se de que seu arquivo .env ou .env.local esteja configurado corretamente.

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID
};

// Validação para garantir que as variáveis de ambiente foram carregadas
if (typeof window !== "undefined" && // Executar apenas no cliente
    (!firebaseConfig.apiKey || !firebaseConfig.authDomain || !firebaseConfig.projectId)) {
  console.error("Firebase config is missing. Make sure your .env.local file is set up correctly.");
  // Poderia lançar um erro aqui ou mostrar uma mensagem para o usuário
}
